/* ==========================================================================
   D-Ring Gift — DFCo
   Intercepts the product-page Add-to-Cart on tagged harnesses, adds the
   size-matched free D-ring alongside the harness in one /cart/add.js call,
   then drives Dawn's cart drawer / notification (or redirects to /cart).
   The D-ring price is set to free by a Buy X Get Y automatic discount.
   ========================================================================== */
(function () {
  'use strict';

  var busy = false;

  function init() {
    var cfg = document.getElementById('dfco-dring-config');
    if (!cfg || cfg.getAttribute('data-active') !== 'true') return;

    var dringSmall = (cfg.getAttribute('data-dring-small') || '').trim();
    var dringLarge = (cfg.getAttribute('data-dring-large') || '').trim();
    var smallSizes = (cfg.getAttribute('data-small-sizes') || '')
      .split(',')
      .map(function (s) { return s.trim().toUpperCase(); })
      .filter(Boolean);
    var giftProp = (cfg.getAttribute('data-gift-property') || '_free_gift').trim();
    var hideDynamic = cfg.getAttribute('data-hide-dynamic') === 'true';
    var forceCart = cfg.getAttribute('data-force-cart') === 'true';

    var variantSize = {};
    var mapEl = document.getElementById('dfco-dring-variant-map');
    if (mapEl) {
      try { variantSize = JSON.parse(mapEl.textContent) || {}; } catch (e) { variantSize = {}; }
    }

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function path(p) { return (root + p).replace(/\/{2,}/g, '/'); }

    // Route every order through the cart so the gift + discount always apply.
    if (hideDynamic) document.documentElement.classList.add('dfco-dring-active');

    // Never intercept inside the theme editor.
    if (window.Shopify && Shopify.designMode) return;

    function giftIdFor(variantId) {
      if (!dringSmall && !dringLarge) return null;
      var size = (variantSize[String(variantId)] || '').toUpperCase();
      if (smallSizes.indexOf(size) !== -1) return dringSmall || dringLarge;
      return dringLarge || dringSmall;
    }

    function cartEl() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    function sectionsToRender() {
      var c = cartEl();
      if (c && typeof c.getSectionsToRender === 'function') {
        return c.getSectionsToRender().map(function (s) { return s.id; });
      }
      return [];
    }

    function done(parsed) {
      busy = false;
      var c = cartEl();
      if (!forceCart && c && typeof c.renderContents === 'function' && parsed) {
        try {
          c.renderContents(parsed);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dfco-dring-gift', cartData: parsed });
          }
        } catch (e) {
          window.location = path('cart');
        }
      } else {
        window.location = path('cart');
      }
    }

    function add(items, cb) {
      var body = { items: items };
      var secs = sectionsToRender();
      if (secs.length) {
        body.sections = secs;
        body.sections_url = window.location.pathname;
      }
      fetch(path('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(cb)
        .catch(function () { cb({ ok: false, data: null }); });
    }

    function lineProps(form) {
      var props = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (el) {
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        var m = el.name.match(/^properties\[(.+)\]$/);
        if (m) props[m[1]] = el.value;
      });
      return props;
    }

    function onSubmit(e) {
      var form = e.target && e.target.closest ? e.target.closest('form') : null;
      if (!form) return;
      if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;

      var idEl = form.querySelector('[name="id"]');
      if (!idEl || idEl.disabled) return; // unavailable / sold out -> let theme handle

      var harnessId = idEl.value;
      var giftId = giftIdFor(harnessId);
      if (!giftId || String(giftId) === String(harnessId)) return; // misconfigured -> normal add

      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy) return;
      busy = true;

      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl && parseInt(qtyEl.value, 10) ? parseInt(qtyEl.value, 10) : 1;

      var harness = { id: harnessId, quantity: qty };
      var props = lineProps(form);
      if (Object.keys(props).length) harness.properties = props;
      var planEl = form.querySelector('[name="selling_plan"]');
      if (planEl && planEl.value) harness.selling_plan = planEl.value;

      var gift = { id: giftId, quantity: 1, properties: {} };
      gift.properties[giftProp] = 'true';

      add([harness, gift], function (res) {
        if (res.ok) { done(res.data); return; }
        // Fallback: never block the sale — add the harness on its own.
        add([harness], function (res2) {
          if (res2.ok) { done(res2.data); } else { busy = false; }
        });
      });
    }

    document.addEventListener('submit', onSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();